import { useState } from 'react';
import { adminLogin } from '../../lib/api/adminApi';

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await adminLogin(password);
      sessionStorage.setItem('admin_auth', '1');
      onLogin();
    } catch {
      setError('Mot de passe incorrect.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-wrap">
      <div className="admin-login-card">
        <div className="admin-login-logo">
          <img src="/logo-tram.png" alt="Logo" />
          <span><span className="t">Tram</span><span className="e">energie</span></span>
        </div>
        <div className="admin-login-title">Espace Administration</div>
        <div className="admin-login-sub">Connectez-vous pour accéder au panneau d'administration.</div>

        <form onSubmit={handleSubmit}>
          {error && <div className="admin-login-error">{error}</div>}
          <label className="admin-login-label">Mot de passe</label>
          <input
            className="admin-login-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            autoFocus
            required
          />
          <button className="admin-login-btn" type="submit" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
